import React from 'react';
import styles from './CoreButtons.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

export default function CoreButtons(props) {
  const { attributes, innerBlocks } = props;
  let layout = JSON.parse(attributes.layout) || {};
  const className = attributes.className?.split(' ') || [];
  const styles = formatStyles(attributes.style);
  
  return (
    <div id={attributes.anchor} className={cx(['ns_buttons', 'buttons', ...className, ...Object.keys(layout).map(key => `${key}-${layout[key]}`)])} style={{...styles}}>
      {React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}
    </div>
  )
}


CoreButtons.fragments = {
  key: `CoreButtonsFragment`,
  entry: gql `
  fragment CoreButtonsFragment on CoreButtons {
    attributes {
      anchor
      className
      layout
      style
    }
  }
`,
};

CoreButtons.config = {
	name: 'CoreButtons',
};
CoreButtons.displayName = 'CoreButtons';